import { type CardholderRfiApiModel } from '@webapp/modules/spending-cards/data-access/api-models/CardholderRfiApiModel'
import { type CardholderRfiConstructor } from '@webapp/modules/spending-cards/entities/CardholderRfi'

export const mapCardholderRfiApiModel = (
  rfi: CardholderRfiApiModel
): CardholderRfiConstructor => ({
  id: rfi.id,
  types: rfi.questions,
})
